import React from 'react';
import { Link } from 'react-router-dom';
import SiteHeader from './SiteHeader';
import Footer from './Footer';
import './SubPage.css';

/**
 * 서브페이지 공통 틀 — 시안의 page-hero + page-body 양식.
 * crumb: 상위 메뉴명, title, lede, children(본문)
 */
function SubPage({ crumb, title, lede, children }) {
  return (
    <>
      <SiteHeader />
      <main className="sp">
        <div className="sp-hero">
          <div className="sp-hero-inner">
            <div className="sp-crumb">
              <Link to="/">Home</Link>
              {crumb && <><span className="sep">›</span><span>{crumb}</span></>}
              <span className="sep">›</span><span className="cur">{title}</span>
            </div>
            <h1>{title}</h1>
            {lede && <p className="lede">{lede}</p>}
          </div>
        </div>
        <div className="sp-body">{children}</div>
      </main>
      <Footer />
    </>
  );
}

export default SubPage;
